import { useState } from "react";
import { ArrowUp, ArrowDown, Plus, X } from "lucide-react";

export default function InvoiceReasonsEditor({ title, reasons, onTitle, onReasons, testIdPrefix = "invoice-reason", placeholder = "Arsye e re, p.sh. Presion i lartë në karter", hint = "Te fatura shfaqen vetëm arsyet që shënon ✓ te shitja.", prices, onPrices, hideTitle = false }) {
    const [newReason, setNewReason] = useState("");

    const add = () => {
        const r = newReason.trim();
        if (!r || reasons.includes(r)) return;
        onReasons([...reasons, r]);
        setNewReason("");
    };
    const move = (i, d) => {
        const j = i + d;
        if (j < 0 || j >= reasons.length) return;
        const list = [...reasons];
        [list[i], list[j]] = [list[j], list[i]];
        onReasons(list);
    };
    const edit = (i, v) => {
        if (prices && reasons[i] in prices) {
            const { [reasons[i]]: p, ...rest } = prices;
            onPrices({ ...rest, [v]: p });
        }
        onReasons(reasons.map((r, k) => (k === i ? v : r)));
    };

    return (
        <div className="space-y-3" data-testid={`${testIdPrefix}s-editor`}>
            <div className={hideTitle ? "hidden" : ""}>
                <label className="label-kicker mb-1 block">Titulli</label>
                <input type="text" value={title} onChange={(e) => onTitle(e.target.value)} className="input-field !py-1.5" data-testid={`${testIdPrefix}s-title`} />
            </div>
            <p className="text-xs text-slate-500">{hint}</p>
            <div className="space-y-1.5">
                {reasons.map((r, i) => (
                    <div key={i} className="flex items-center gap-1.5" data-testid={`${testIdPrefix}-row-${i}`}>
                        <span className="font-mono text-[10px] text-slate-400 w-5 text-right">{i + 1}</span>
                        <input type="text" value={r} onChange={(e) => edit(i, e.target.value)} className="input-field !py-1 !text-xs flex-1" data-testid={`${testIdPrefix}-input-${i}`} />
                        {prices && (
                            <span className="flex items-center gap-1">
                                <input type="number" min="0" step="50" value={prices[r] ?? ""} onChange={(e) => onPrices({ ...prices, [r]: Math.max(0, parseFloat(e.target.value) || 0) })} placeholder="0" className="input-field !py-1 !text-xs !w-24 text-right font-mono" data-testid={`${testIdPrefix}-price-${i}`} />
                                <span className="font-mono text-[10px] text-slate-500">Lek</span>
                            </span>
                        )}
                        <button type="button" onClick={() => move(i, -1)} disabled={i === 0} className="p-1 text-slate-500 disabled:opacity-30" data-testid={`${testIdPrefix}-up-${i}`}><ArrowUp className="w-3.5 h-3.5" /></button>
                        <button type="button" onClick={() => move(i, 1)} disabled={i === reasons.length - 1} className="p-1 text-slate-500 disabled:opacity-30" data-testid={`${testIdPrefix}-down-${i}`}><ArrowDown className="w-3.5 h-3.5" /></button>
                        <button type="button" onClick={() => onReasons(reasons.filter((_, k) => k !== i))} className="p-1 text-red-600" data-testid={`${testIdPrefix}-remove-${i}`}><X className="w-3.5 h-3.5" /></button>
                    </div>
                ))}
            </div>
            <div className="flex gap-2">
                <input type="text" value={newReason} onChange={(e) => setNewReason(e.target.value)} onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), add())} placeholder={placeholder} className="input-field !py-1.5 !text-xs flex-1" data-testid={`${testIdPrefix}-new-input`} />
                <button type="button" onClick={add} className="btn-outline !py-1.5 !text-xs" data-testid={`${testIdPrefix}-add`}><Plus className="w-3.5 h-3.5" /> Shto</button>
            </div>
        </div>
    );
}
